import { FC } from "react";
import { Control, useController } from "react-hook-form";
import styled from "styled-components";

import { FormDataT } from "./DistributionScheduleModal";
import { Controls, ControlsButton } from "@/components/Controls";

const StyledControls = styled(Controls)`
  display: flex;
`;

const StyledControlsButton = styled(ControlsButton)`
  flex: 1;
  justify-content: center;
  height: 34px;
`;

interface Props {
  control: Control<FormDataT>;
}

const VideoReelSwitchField: FC<Props> = ({ control }) => {
  const { field } = useController<FormDataT, "is_reel">({
    name: "is_reel",
    control,
  });

  return (
    <StyledControls>
      <StyledControlsButton
        active={!field.value}
        type="button"
        onClick={() => field.onChange(0)}
      >
        Video
      </StyledControlsButton>
      <StyledControlsButton
        active={!!field.value}
        type="button"
        onClick={() => field.onChange(1)}
      >
        Reels
      </StyledControlsButton>
    </StyledControls>
  );
};

export default VideoReelSwitchField;
